/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const exclamation_triangle = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 9.06V5.88m-.177 6.133h.346m6.612-.257a2.038 2.038 0 0 1-.09 1.998 2.083 2.083 0 0 1-1.761.973H3.07a2.082 2.082 0 0 1-1.761-.973 2.04 2.04 0 0 1-.09-1.998l4.93-8.62c.171-.342.435-.629.762-.83a2.082 2.082 0 0 1 2.94.83l4.93 8.62Zm-6.533.257c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    />
  </svg>
)
export default exclamation_triangle
